import { useSelector } from 'react-redux';

/**
 * Get "templates" object from store
 *
 * @returns {object} - templates from store
 */
export const useTemplates = () => useSelector(state => state.templates);
